<nav class="navbar">
  <div class="logo-container">
    <img src="http://35.196.246.226/wp-content/uploads/2017/11/logo-icon-white@2x.png" alt="App Logo" class="logo" />
  </div>
</nav>






<div class="scraper-container">
  <h2 class="scraper-title">🕷️ Web Scraper</h2>
  <mat-button-toggle-group class="toggle" (change)="onToggleChange($event)" name="fontStyle" aria-label="Font Style">
    <mat-button-toggle value="file">File</mat-button-toggle>
    <mat-button-toggle value="database">Database</mat-button-toggle>
  </mat-button-toggle-group>

  <div *ngIf="selectedType === 'file'" class="scraper-section">
    <h3>Scrape from Url:</h3>

    <input [(ngModel)]="url" placeholder="https://example.com" class="scraper-input" />
    <button (click)="scrape()" class="scraper-button">Scrape</button>
  </div>

  <div *ngIf="selectedType === 'file'" class="scraper-section">
    <h3>Upload a File:</h3>
    <form (ngSubmit)="onSubmitUpload()" enctype="multipart/form-data">
      <input type="file" id="fileInput" (change)="onFileSelected($event)" accept=".txt,.pdf,.html" />
      <button type="submit" class="scraper-button">Upload</button>
    </form>
  </div>



  <form *ngIf="selectedType === 'database'" [formGroup]="db_form" (ngSubmit)="onSubmit()">
    <mat-label>Database Type</mat-label>
    <mat-select (selectionChange)="selectdb($event)" [(value)]="db_selected" formControlName="db_type"
      class="scraper-input">
      <mat-option value="mysql">MySQL</mat-option>
      <mat-option value="postgres">PostgreSQL</mat-option>
      <mat-option value="mongodb">MongoDB</mat-option>
      <mat-option value="sqlite">Sqlite</mat-option>
    </mat-select>
    <label *ngIf="db_selected !== 'sqlite'" for="hostname">Hostname/IP Address/Url: </label>
    <input *ngIf="db_selected !== 'sqlite'" id="hostname" type="text" formControlName="hostname"
      class="scraper-input" />
    <label *ngIf="db_selected !== 'sqlite'" for="port">Port: </label>
    <input *ngIf="db_selected !== 'sqlite'" id="port" type="text" formControlName="port" class="scraper-input" />
    <label *ngIf="db_selected !== 'sqlite'" for="name">Name: </label>
    <input *ngIf="db_selected !== 'sqlite'" id="name" type="text" formControlName="name" class="scraper-input" />
    <label *ngIf="db_selected !=='sqlite'" for="username">Username: </label>
    <input *ngIf="db_selected !== 'sqlite'" id="username" type="text" formControlName="username"
      class="scraper-input" />
    <label *ngIf="db_selected !=='sqlite'" for="password">Password: </label>
    <input *ngIf="db_selected !== 'sqlite'" id="password" type="text" formControlName="password"
      class="scraper-input" />
    <label *ngIf="db_selected === 'sqlite'" for="password">FilePath: </label>
    <input *ngIf="db_selected === 'sqlite'" id="password" type="text" formControlName="filepath"
      class="scraper-input" />
    <button class="scraper-button" ngSubmit>Scrape</button>
  </form>
  <button *ngIf="selectedType === 'url'" (click)="scrape()" class="scraper-button">Scrape</button>

  <div *ngIf="error" class="scraper-error">{{ error }}</div>
  <div *ngIf="result" class="scraper-results">
    <h3>{{ result.title }}</h3>

    <div *ngFor="let para of result.paragraphs" style="margin-bottom: 1em">
      <ul *ngIf="para.includes('•'); else plainText">
        <li *ngFor="let item of para.split('•').slice(1)">
          {{ item.trim() }}
        </li>
      </ul>
      <ng-template #plainText>
        <p style="text-align: justify">{{ para }}</p>
      </ng-template>
    </div>

    <div *ngFor="let table of allTables">
      <h2>{{ table.tableName }}</h2>
      <table mat-table [dataSource]="table.dataSource" class="mat-elevation-z8">

        <ng-container *ngFor="let column of table.displayedColumns" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
          <td mat-cell *matCellDef="let row">{{ row[column] }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="table.displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: table.displayedColumns;"></tr>
      </table>
      <br />
    </div>

    <div *ngIf="result.type === 'text'">
      <h4>📄 Plain Text Summary</h4>
      <p><strong>Lines:</strong> {{ result.line_count }}</p>
      <p><strong>Words:</strong> {{ result.word_count }}</p>
    </div>



    <div *ngIf="result.headings">
      <h4>Headings</h4>
      <div *ngFor="let key of headingKeys(result.headings)">
        <strong>{{ key }}:</strong>
        <ul>
          <li *ngFor="let h of result.headings[key]">{{ h }}</li>
        </ul>
      </div>
    </div>

    <div *ngIf="result.links?.length">
      <h4>Links</h4>
      <ul>
        <li *ngFor="let l of result.links">
          <a [href]="l.href" target="_blank">{{ l.text || l.href }}</a>
        </li>
      </ul>
    </div>

    <div *ngIf="result.images?.length">
      <h4>Images</h4>
      <div *ngFor="let img of result.images">
        <img [src]="img.src" [alt]="img.alt" />
      </div>
    </div>

    <div *ngIf="result.meta?.length">
      <h4>Meta Tags</h4>
      <ul>
        <li *ngFor="let m of result.meta">
          <strong>{{ m.name || m.property }}</strong>: {{ m.content }}
        </li>
      </ul>
    </div>
  </div>
</div>